var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 8,
    fill: "#FFF5D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    clipPath: "url(#clip0_1_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 11.25V13.83H7V11.25C7 9.83571 8.15714 8.67857 9.57143 8.67857H12.5714V11.2157C12.5714 11.6871 12.9571 12.0729 13.4286 12.0729C13.9 12.0729 14.2857 11.6871 14.2857 11.2157V8.67857H23.7143V11.2157C23.7143 11.6871 24.1 12.0729 24.5714 12.0729C25.0429 12.0729 25.4286 11.6871 25.4286 11.2157V8.67857H28.4286C29.8429 8.67857 31 9.83571 31 11.25ZM24.1429 24.1243H30.4771L23.2857 30.5357V24.9814C23.2857 24.51 23.6714 24.1243 24.1429 24.1243Z",
    fill: "#ECBF41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 15.5457V22.4114H24.1429C22.7286 22.4114 21.5714 23.5686 21.5714 24.9829V31H9.57143C8.15714 31 7 29.8429 7 28.4286V15.5457H31ZM14.2857 7.85714V8.68H12.5714V7.85714C12.5714 7.38571 12.9571 7 13.4286 7C13.9 7 14.2857 7.38571 14.2857 7.85714ZM25.4286 7.85714V8.68H23.7143V7.85714C23.7143 7.38571 24.1 7 24.5714 7C25.0429 7 25.4286 7.38571 25.4286 7.85714Z",
    fill: "#ECBF41"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3037 19.8906H12.5439L14.3701 25.1104L16.1963 19.8906H17.4365L14.8682 27H13.8721L11.3037 19.8906ZM10.6348 19.8906H11.8701L12.0947 24.9785V27H10.6348V19.8906ZM16.8701 19.8906H18.1104V27H16.6455V24.9785L16.8701 19.8906Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2);
export default __webpack_public_path__ + "static/media/c2.0aa4ecec6bc94990ded15f9fbb326b9c.svg";
export { ForwardRef as ReactComponent };